/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

const DialogButton = (props) => {
    
    const { t } = useTranslation();
    const setOpen = props.setOpen;

    const openDialog = () => {
        setOpen(true);
    };

    return (
        <div style={{
            width: "100%",
            height: "96px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #CECECE",
            borderRadius: "4px",
            color: "#7A7A7A",
            textAlign: "center"
        }}
        >
            <Button
                color='primary'
                variant='contained'
                onClick={openDialog}
            >
                <AddIcon style={{ marginRight: "8px" }}/>
                {t("commons.selectWebpage")}
            </Button>
        </div>
    );
};

export default DialogButton;
